import { render, staticRenderFns } from "./LogoGenerated.vue?vue&type=template&id=826f62d6&scoped=true&"
import script from "./LogoGenerated.vue?vue&type=script&lang=js&"
export * from "./LogoGenerated.vue?vue&type=script&lang=js&"
import style0 from "./LogoGenerated.vue?vue&type=style&index=0&id=826f62d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826f62d6",
  null
  
)

export default component.exports